// Polyfills
import '@babel/polyfill';
// eslint-disable-next-line no-restricted-imports
import 'common/polyfills/element-closest';
import 'event-source-polyfill/src/eventsource';
import 'intersection-observer';
import 'intl';
import 'url-polyfill';
// eslint-disable-next-line no-restricted-imports
import 'vendor/ChildNode.remove.polyfill'; // custom addition on line 12: if (this.parentNode !== null)
import 'whatwg-fetch';

import 'init';

import React from 'react';
import ReactDOM from 'react-dom';

import * as singleSpa from 'single-spa';

import * as ClassicApp from 'singlespa/apps/classic';
import * as GammaApp from 'singlespa/apps/gamma';
import Interceptor from 'singlespa/interceptor';

// eslint-disable-next-line no-restricted-imports
import API from 'api';
// eslint-disable-next-line no-restricted-imports
import Storage from 'common/lib/storage';
// eslint-disable-next-line no-restricted-imports
import Token from 'common/lib/util/token';
// eslint-disable-next-line no-restricted-imports
import Analytics, { buildContextGetter } from 'debug/analytics';
// eslint-disable-next-line no-restricted-imports
import { defaultStore } from 'gamma/defaultStore';
// eslint-disable-next-line no-restricted-imports
import { setMember } from 'gamma/modules';
// eslint-disable-next-line no-restricted-imports
import experiment from 'gamma/util/experiments';

// eslint-disable-next-line no-restricted-imports
import { Chrome } from 'views/chrome/Chrome';

// eslint-disable-next-line no-restricted-imports
import { featureFlagClient } from 'common/lib/feature-flag-client';

// This is a "loading function" Inside of it, the import introduces a code splitting
// point. Webpack will create separate code chunks that will be lazy loaded by single-spa.
const loadGamma = () => Promise.resolve().then(() => GammaApp);
const loadClassic = () => Promise.resolve().then(() => ClassicApp);

// This is an "activity function"
// this is where we'd check for whether this is a classic or gamma url ... rather than use window location
const isGammaActive = () => Interceptor.isGammaRoute(window.location.pathname);
const isClassicActive = () => !isGammaActive();

// Register the application with single-spa
singleSpa.registerApplication('gamma', loadGamma, isGammaActive);
singleSpa.registerApplication('classic', loadClassic, isClassicActive);

// Redux store setup, included here so that we can safely assume it's present early
API.setStore(defaultStore);
experiment.setStore(defaultStore);
Analytics.setAppContextGetter(buildContextGetter(defaultStore));
Storage.setStore(defaultStore);
defaultStore.dispatch(setMember({ idMe: Token.getMyId() }));

// Wait for the ldclient to be ready before rendering the root component. This
// is necessary (even though we bootstrap feature flags from localStorage)
// because the ldclient will return default values for flags until after it is
// finished initializing (deferred to the next turn of the event loop).
const ldClientInitialized = featureFlagClient.client.waitForInitialization();
// Manually time the ldclient out after 10 seconds, in case something prevents
// the ldclient from properly initializing
const ldClientTimeoutThreshold = 10 * 1000;
const ldClientTimeout = new Promise((resolve, reject) => {
  setTimeout(reject, ldClientTimeoutThreshold);
});

// Race the ldclient initialization against the timeout, using .finally()
// because we don't care about the outcome.
Promise.race([ldClientInitialized, ldClientTimeout]).finally(() => {
  ReactDOM.render(<Chrome />, document.getElementById('chrome-container'));
});



// WEBPACK FOOTER //
// ./app/scripts/entry/app.js